// Publication succeeds independently of the mail provider. Show the actual send outcome.
export function showCollectionLaunchNotification(message, result) {
  if (!result) return
  const data = result.data || {}
  if (result.code !== 0 || (data.errors && data.errors.length)) {
    message.warning('Collection published, but some launch emails could not be sent. Open the course editor and use Retry launch emails.')
  } else if (data.sent > 0) {
    message.success(`Launch email sent to ${data.sent} learner${data.sent === 1 ? '' : 's'}.`)
  }
}
